var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoritesHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "favorites",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.007,
    height: 58.88,
    viewBox: "0 0 46.007 58.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb63f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4513"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1249.616-470.55v-4.313l7.108,7.348h-4.073A3.035,3.035,0,0,1,1249.616-470.55Z",
    transform: "translate(-1211.488 475.724)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1249.842-465.47a4.254,4.254,0,0,1-4.254-4.253v-6.045H1213.8a4.254,4.254,0,0,0-4.254,4.253v50.373a4.255,4.255,0,0,0,4.254,4.254h37.5a4.254,4.254,0,0,0,4.254-4.254V-465.47Zm-7.4,21.1a1.364,1.364,0,0,0-.035.187,7.652,7.652,0,0,1-1.222,3.6,13.57,13.57,0,0,1-2.482,2.767,46.841,46.841,0,0,1-5.772,4.329.628.628,0,0,1-.776,0,51.754,51.754,0,0,1-4.741-3.455,18.446,18.446,0,0,1-3.106-3.082,7.745,7.745,0,0,1-1.409-6.768,5.052,5.052,0,0,1,2.643-3.352,6.07,6.07,0,0,1,3.551-.666,4.546,4.546,0,0,1,3.321,1.81c.119.16.163.122.261-.009a4.28,4.28,0,0,1,2.253-1.579,6.007,6.007,0,0,1,4.776.528,5.153,5.153,0,0,1,2.487,3.208,9.732,9.732,0,0,1,.251,1.479Z",
    transform: "translate(-1209.544 475.768)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesHome);
export default __webpack_public_path__ + "static/media/favoritesHome.049651ff7fbba23726be6f84511f848e.svg";
export { ForwardRef as ReactComponent };